<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    name: 'App',
    mounted() {
      this.setTableHeight();
    },
    methods: {
      // 获取默认表格高度
      setTableHeight() {
        let tableHeight = document.body.clientHeight - 350 + 'px';
        this.$store.dispatch('app/setTableHeight', tableHeight);
      },
    },
  };
</script>
<style lang="scss">
  @import '../static/css/main.scss';
  @import '../static/css/base.scss';
  @import '../static/css/color-dark.scss'; /* 深色主题 */</style
>>
